import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit,
} from '@angular/core';
import {OverlayPanelRef} from '@common/core/ui/overlay-panel/overlay-panel-ref';
import {OVERLAY_PANEL_DATA} from '@common/core/ui/overlay-panel/overlay-panel-data';
import {upgradeOverlayMsgForBtn} from './upgrade-overlay-message';
import {Settings} from '@common/core/config/settings.service';
import {PermissionBtnConfig} from '../permission-aware-button/permission-aware-button.component';

export interface UpgradeOverlayData {
    config: Pick<PermissionBtnConfig, 'resource'|'createMsgType'>;
}

@Component({
    selector: 'upgrade-overlay',
    templateUrl: './upgrade-overlay.component.html',
    styleUrls: ['./upgrade-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {class: 'permission-overlay'},
})
export class UpgradeOverlayComponent implements OnInit {
    message: string;
    siteName: any;
    constructor(
        private overlayPanelRef: OverlayPanelRef,
        @Inject(OVERLAY_PANEL_DATA) public data: UpgradeOverlayData,
        private settings: Settings
    ) {}

    ngOnInit(): void {
        this.message = upgradeOverlayMsgForBtn(
            this.data.config.resource,
            this.data.config.createMsgType
        );
        this.siteName = this.settings.get('branding.site_name');
    }
}
